module.exports = __webpack_public_path__ + "static/media/pre-acceptance-complete.c3525983.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pre-acceptance-complete.svg
// module id = 707
// module chunks = 0